//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiHeader from "../../components/header/Index.vue";
import HiButton from "../../components/button/Index.vue";
import InstagramUserItem from "../../components/plan/instagram_user_item/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import { showErrorMsg } from "../../utils/error";
import moment from "moment";

export default {
  name: "AddAutoPostPage",
  components: { HiHeader, InstagramUserItem, HiButton },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * 计算列表
     * @returns {Array}
     */
    unlimitedUsers() {
      // 根据类型进行分组(只保留unlimited)
      return this.user.linkedInstagramList.filter(
        (l) => l.isUnlimited && !l.isMember
      );
    },
    insUnlimitedUser() {
      return this.unlimitedUsers.filter((u) => u.socialNetwork === 1);
    },
    /**
     * 计算unlimited最大数量
     */
    maxUnlimitedAutoPostNum() {
      return this.user.plan.premiumPublisherCount;
    },
  },
  methods: {
    /**
     * 删除选项(废弃，以后该页面不能删除)
     * @param item 对应项
     */
    async remove(item) {
      const message = `If you remove this Instagram from unlimited schedules, you can only change to another after ${moment(
        this.user.plan.nextLimitTime
      ).format("MMM DD, YYYY")}. Do you want to remove?`;
      await this.$confirm.show({
        title: "30 Days Anti-Spam Lock",
        text: message,
        yesText: "Remove",
      });
      try {
        this.$loading.show();
        await item.removeUnlimited();
        // 当全部删除时直接返回上一页
        if (this.unlimitedUsers.length === 0) {
          this.$router.go(-1);
        }
        this.$toast.show({ message: this.$t("common.success") });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/auto_post_account/ModifyAutoPost.vue